import { create } from 'zustand';

interface BreadcrumbItem {
  labelKey: string;
  href?: string;
}

interface BreadcrumbState {
  items: BreadcrumbItem[];
  setItems: (items: BreadcrumbItem[]) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  items: [],
  setItems: (items) => {
    set({ items });
  },
}));
